import { withTheme } from '@mui/styles';
import styled from 'styled-components';

const WhyChooseUsSectionStyle = withTheme(styled.div`
  padding: 60px 0px;
  background: #f7f7f7;

  .front-card {
    background: ${(props: any) => props.theme.palette.primary.dark};
    width: 100%;
    height: 100%;
    color: white;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      margin-bottom: 25px;
    }
    .MuiTypography-root {
      font-size: 22px;
      font-weight: bold;
    }
  }
  .back-card {
    background: #cecece;
    width: 100%;
    height: 100%;
    padding: 10px;

    .title {
      font-size: 24px;
      font-weight: bold;
      color: #4a4a4a;
      line-height: 1.1;
    }
    .content {
      color: #4a4a4a;
      font-size: 16px;
      font-weight: bold;
      line-height: 1.1;
    }
  }
  .next-button {
    position: absolute;
    top: 217px;
    right: 5px;
    width: 30px;
    height: 30px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: white;
    border-radius: 50%;
    z-index: 1;
    color: ${(props: any) => props.theme.palette.primary.dark};
  }
  .previous-button {
    position: absolute;
    top: 217px;
    left: 5px;
    width: 30px;
    height: 30px;
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
    background-color: white;
    border-radius: 50%;
    z-index: 1;
    color: ${(props: any) => props.theme.palette.primary.dark};
  }
`);

export default WhyChooseUsSectionStyle;
